import React from "react";
import { NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, UtensilsCrossed, QrCode, BarChart3, MessageSquare, Award, Settings, LogOut, AlertTriangle } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/lib/auth";

const links = [
  { to: "/dashboard", icon: LayoutDashboard, label: "Overview", end: true },
  { to: "/dashboard/menu", icon: UtensilsCrossed, label: "Menu" },
  { to: "/dashboard/qr", icon: QrCode, label: "QR Code" },
  { to: "/dashboard/analytics", icon: BarChart3, label: "Analytics" },
  { to: "/dashboard/feedback", icon: MessageSquare, label: "Feedback" },
  { to: "/dashboard/loyalty", icon: Award, label: "Loyalty" },
  { to: "/dashboard/settings", icon: Settings, label: "Settings" },
];

export const RestaurantLayout = () => {
  const { user, restaurant, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen flex bg-zq-cream">
      <aside className="w-64 zq-side flex-col p-4 hidden md:flex">
        <Link to="/dashboard" className="px-2 py-3"><Logo light /></Link>
        <div className="px-2 mt-2 text-xs text-gray-400">{restaurant?.name}</div>
        <nav className="mt-6 flex-1 space-y-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`rest-nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm transition ${isActive ? "active" : ""}`
              }
            >
              <l.icon size={18}/> {l.label}
            </NavLink>
          ))}
        </nav>
        <button
          className="flex items-center gap-2 px-3 py-2 text-sm text-gray-300 hover:text-zq-orange"
          onClick={async () => { await logout(); nav("/login"); }}
          data-testid="rest-logout"
        >
          <LogOut size={16} /> Logout
        </button>
      </aside>

      <div className="flex-1 flex flex-col">
        <header className="h-14 bg-white border-b border-zq-border px-5 flex items-center justify-between">
          <span className="text-sm text-zq-muted">Restaurant · {restaurant?.name}</span>
          <span className="text-sm font-medium">{user?.name}</span>
        </header>
        {restaurant?.suspended && (
          <div className="bg-red-50 border-b border-red-200 px-5 py-3 flex items-center gap-2 text-sm text-red-700">
            <AlertTriangle size={18} />
            Your account is suspended. Menu editing is disabled. Please contact your account manager.
          </div>
        )}
        <main className="flex-1 p-5 md:p-8"><Outlet /></main>
      </div>
    </div>
  );
};
